export const trackPixelEvent = (
  event: string,
  data: Record<string, string>,
) => {
  try {
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("trackCustom", event, data);
    }
  } catch (error) {
    console.error("Failed to track pixel event:", error);
  }
};
